import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Button, Heading } from '../components';

const textColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.midLightGrey,
});

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.white,
  dark: (props) => props.theme.colors.cyanDarker,
});

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.midLightGrey,
});

const Text = styled(Flex)`
  font-weight: 300;
  line-height: 1.5;
  color: ${textColor};
`;

const HomeCardContainer = styled(Box)`
  max-width: 900px;
  min-width: 500px;
  height: 242px;
  background: ${backgroundColor};
  border-radius: 6px;
`;

const IconWrapper = styled(Box)`
  color: ${iconColor};
`;

const ICON_SIZE = 70;

function HomeCard(props) {
  const {
    title, content, Icon, history, buttons, ...otherProps
  } = props;

  const handleClick = (route) => history.push(route);

  return (
    <HomeCardContainer p={5} {...otherProps}>
      <Box fontSize={1}>
        <Heading fontSize={3} fontWeight={400} mb={3}>
          {title}
        </Heading>
        <Flex justifyContent="space-between">
          <Text pr={3}>{content}</Text>
          <IconWrapper pr={7} height={ICON_SIZE} width={ICON_SIZE}>
            <Icon
              title={title}
              alt={title}
              height={ICON_SIZE}
              width={ICON_SIZE}
            />
          </IconWrapper>
        </Flex>
        {buttons && (
          <Flex pt={4} width="440px" justifyContent="space-between">
            {buttons.map((button) => <Button key={button.name} variant="secondary" onClick={() => handleClick(button.route)}>{`Go to ${button.name}`}</Button>)}
          </Flex>
        )}

      </Box>
    </HomeCardContainer>
  );
}

HomeCard.defaultProps = {
  title: undefined,
  content: undefined,
  Icon: undefined,
  buttons: [],
};

HomeCard.propTypes = {
  history: PropTypes.object.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  Icon: PropTypes.object,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      route: PropTypes.string,
    }),
  ),
};

export default HomeCard;
